// extracted by mini-css-extract-plugin
export var borderRadius = "_9m-4";
export var large = "_9m-3";
export var logoContainer = "_9m-0";
export var nameLogo = "_9m-2";
export var small = "_9m-1";